import { getLeafValue } from "../../helper";
import { VisitNodePassage } from "../../types";
export const getLeafValuesVisitor = () => (args) => {
    if (args?.context?.visitNodePassage !== VisitNodePassage.Leaf) {
        return;
    }
    const { visitable: element } = args;
    if (element?.measures) {
        Object.keys(element.measures).forEach((key) => {
            if (element.measures) {
                element.measures[key] = getLeafValue(element.measures[key]);
            }
        });
    }
};
